import { Component, OnInit } from '@angular/core';
import { NgIdleService } from './services/idle-service/ng-idle.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'app';

  constructor(private ngIdleService:NgIdleService){

  }

  ngOnInit(): void {
    this.ngIdleService.reset();
  }
}
